import { createContext, useContext, useState } from "react";

const dict = {
  nl: {
    nav: { home: "Home", diensten: "Diensten", verhuur: "Verhuur", tekoop: "Te koop", offerte: "Offerte", afspraak: "Afspraak", over: "Over ons", contact: "Contact", bellen: "Bellen", whatsapp: "WhatsApp" },
    hero: {
      badge: "Automotive Service • Diagnostics • Mobility",
      title: "Uw complete autopartner in Antwerpen",
      sub: "Onderhoud, reparaties, diagnose, autokeuring, sleepdienst, verhuur en mobiele diagnose aan huis.",
      cta1: "Maak een afspraak", cta2: "Vraag offerte aan", cta3: "WhatsApp ons",
      p1: "Ervaren monteurs", p2: "Transparante prijzen", p3: "Snelle communicatie",
    },
    home: {
      servicesTitle: "Onze diensten", servicesSub: "Van klein onderhoud tot complete elektronische diagnose — alles onder één dak in Antwerpen.",
      howTitle: "Zo werkt het",
      steps: [
        { t: "1. Kies uw dienst", d: "Selecteer wat uw auto nodig heeft." },
        { t: "2. Deel uw voertuiggegevens", d: "Merk, model, kenteken en foto's van het probleem." },
        { t: "3. Wij bevestigen", d: "Offerte of afspraak — wij nemen snel contact op via WhatsApp, telefoon of e-mail." },
      ],
      whyTitle: "Waarom Milano Worx?",
      whyItems: ["Professionele diagnose", "Persoonlijke service", "Transparante prijzen", "Ervaren monteurs", "Snelle communicatie", "Complete autoservice", "WhatsApp contact", "Service voor particulieren en bedrijven"],
      reviewsTitle: "Wat onze klanten zeggen",
      reviewsSub: "Echte ervaringen van klanten uit Antwerpen en omgeving.",
      reviewsCta: "Bekijk onze Google reviews",
      reviewsNote: "Live Google reviews worden binnenkort geïntegreerd.",
      fleetTitle: "Zakelijke klanten & wagenparken",
      fleetDesc: "Milano Worx werkt samen met bedrijven met personenwagens, bestelwagens en kleine wagenparken.",
      fleetItems: ["Onderhoud & reparaties", "Diagnose", "Keuring", "Banden", "Snelle planning", "Prioriteit voor fleet-klanten"],
      fleetCta: "Zakelijke samenwerking aanvragen",
      garageTitle: "Onze werkplaats in Hoboken",
      garageSub: "Ijskelderstraat 12, 2660 Hoboken — hier staat uw auto in goede handen.",
      rentalTitle: "Auto & bestelwagen huren",
      rentalSub: "Flexibel huren per dag, week of maand. Vraag online aan — wij bevestigen de beschikbaarheid.",
      rentalCta: "Bekijk verhuur",
      ctaTitle: "Klaar om te starten?",
      ctaSub: "Vraag vandaag een offerte aan of maak direct een afspraak.",
    },
    press: {
      title: "In de pers",
      sub: "Het district Hoboken zette Milano Worx in de schijnwerpers als ondernemer van de maand.",
      articleTitle: "“Vakmanschap bij de broers van Milano Worx”",
      quote: "“We krijgen dikwijls het compliment van onze klanten dat we eerlijk zijn. We gaan op zoek naar het probleem en maken er een foto van als bewijs. Zo voelen ze zich veilig.”",
      source: "antwerpen.be — District Hoboken",
      cta: "Lees het volledige artikel",
      credit: "Foto: Pieter De Wilde / antwerpen.be",
    },
    pay: {
      title: "Aanbetaling €15",
      sub: "Milano Worx heeft je aanvraag bevestigd. Betaal de aanbetaling om je afspraak definitief te maken. De rest betaal je na de service.",
      service: "Dienst", ref: "Referentie",
      online: "Betaal €15 online",
      onlineDesc: "Kaart, Bancontact of Apple Pay — veilig via Stripe",
      transfer: "Overschrijving",
      iban: "IBAN", beneficiary: "Begunstigde", communication: "Mededeling",
      copy: "Kopieer", copied: "Gekopieerd!",
      transferNote: "Gebruik de referentie als mededeling. Je betaling wordt handmatig bevestigd.",
      waitConfirm: "Milano Worx bevestigt je aanvraag eerst. Je ontvangt daarna een betaalverzoek.",
      alreadyPaid: "Aanbetaling ontvangen — bedankt! Je afspraak is definitief.",
      redirecting: "Doorsturen naar de betaalpagina...",
      err: "Betaling kon niet worden gestart. Probeer opnieuw of betaal per overschrijving.",
      checking: "Betaling controleren...",
      ok: "Betaling ontvangen",
      okText: "Je aanbetaling van €15 is geslaagd. Milano Worx bevestigt je afspraak definitief.",
      fail: "Betaling nog niet bevestigd",
      failText: "De betaling is nog niet zichtbaar. Net betaald? Wacht even en herlaad de pagina.",
      cancelTitle: "Betaling geannuleerd",
      cancelText: "Geen probleem — je kunt later opnieuw betalen via de link die je hebt ontvangen.",
      home: "Terug naar home",
    },
    cards: [
      { id: "onderhoud", title: "Onderhoud & Reparatie", desc: "Klein en groot onderhoud, olie, remmen, distributie, koppeling, ophanging, airco en meer.", badge: "Populair" },
      { id: "diagnose", title: "Diagnose & Elektronica", desc: "Foutcodes uitlezen, ECU-diagnose, sensoren en elektrische storingen opsporen.", badge: "High-Tech" },
      { id: "mobiel", title: "Mobiele Diagnose", desc: "Diagnose bij u thuis of op het werk — op afspraak in regio Antwerpen.", badge: "Aan huis" },
      { id: "keuring", title: "Autokeuring Service", desc: "Z-plaat keuring, keuring voor verkoop en periodieke keuring.", badge: "Zorgeloos" },
      { id: "sleep", title: "Sleepdienst", desc: "Pech of auto defect? Snelle takeldienst in Antwerpen en omgeving.", badge: "24/7" },
      { id: "verhuur", title: "Auto & Bestelwagen", desc: "Huurauto's en bestelwagen per dag, week of maand.", badge: "Flexibel" },
      { id: "tekoop", title: "Auto's te koop", desc: "Gecontroleerde tweedehandswagens, klaar voor de keuring.", badge: "Occasions" },
    ],
    svc: {
      onderhoud: {
        title: "Onderhoud & Reparatie",
        desc: "Complete algemene garageservice voor alle merken — van klein onderhoud tot complexe motorreparaties.",
        items: ["Klein onderhoud", "Groot onderhoud", "Olie vervangen", "Remmen", "Distributieriem", "Distributieketting", "Koppeling", "Ophanging", "Motorproblemen", "Koelsysteem", "Elektrische storingen", "Airco", "Algemene reparaties"],
      },
      diagnose: {
        title: "Diagnose & Elektronica",
        desc: "Professionele elektronische diagnose met moderne apparatuur voor alle merken.",
        items: ["Foutcodes uitlezen", "Elektronische diagnose", "Storingen zoeken", "ECU diagnose", "Sensoren", "Elektrische problemen", "Programmering/codering waar beschikbaar"],
        cta: "Diagnose afspraak maken",
      },
      mobiel: {
        title: "Mobiele Diagnose aan Huis",
        desc: "Lampje op het dashboard of startprobleem? Wij komen op afspraak bij u thuis of op kantoor in regio Antwerpen.",
        success: "Bedankt. Milano Worx neemt zo snel mogelijk contact met u op om de afspraak te bevestigen.",
        wa: "Direct via WhatsApp aanvragen",
      },
      keuring: {
        title: "Autokeuring Service",
        z: "Z-plaat Autokeuring", zd: "Wij brengen uw voertuig met onze Z-plaat service naar de keuring, waar toepasselijk.",
        verk: "Keuring voor verkoop", verkd: "Volledige begeleiding voor de keuring vóór de verkoop van uw voertuig.",
        per: "Periodieke keuring", perd: "Wij assisteren u bij de normale periodieke keuring van uw auto.",
        disclaimer: "Let op: de uiteindelijke goedkeuring van het voertuig hangt altijd af van het officiële controleorganisme.",
        cta: "Keuring aanvragen",
        services: ["Z-plaat autokeuring", "Keuring voor verkoop", "Periodieke keuring"],
        serviceLabel: "Gewenste dienst",
        success: "Bedankt voor uw aanvraag. Wij nemen contact op om de keuring in te plannen.",
      },
      sleep: {
        title: "Pech of auto defect? Wij helpen u.",
        sub: "Sleepdienst in Antwerpen en omgeving — snel ter plaatse.",
        big: "Sleepdienst aanvragen",
        waLoc: "Locatie via WhatsApp sturen",
        call: "Bel ons",
        drives: "Rijdt de auto nog?",
        yes: "Auto rijdt", no: "Auto rijdt niet",
        reason: "Reden van de aanvraag", loc: "Huidige locatie", dest: "Bestemming", photo: "Foto (optioneel)",
        success: "Bedankt. Onze sleepdienst neemt zo snel mogelijk contact met u op.",
      },
    },
    form: {
      name: "Naam", phone: "Telefoonnummer", email: "E-mailadres", address: "Adres",
      brand: "Merk", model: "Model", year: "Bouwjaar", plate: "Nummerplaat", vin: "VIN / chassisnummer (optioneel)",
      km: "Kilometerstand", fuel: "Brandstof", transmission: "Transmissie",
      date: "Gewenste datum", time: "Gewenste tijd", remarks: "Opmerkingen",
      problem: "Beschrijf het probleem", photos: "Foto's uploaden (max. 5)",
      gdpr: "Ik ga akkoord met de verwerking van mijn gegevens volgens de privacyverklaring.",
      preferred: "Voorkeur contact", service: "Type dienst", slot: "Tijdsblok",
      fuels: ["Benzine", "Diesel", "Hybride", "Elektrisch", "LPG"],
      transmissions: ["Manueel", "Automaat"],
      prefs: ["WhatsApp", "Telefoon", "E-mail"],
      depositNote: "Na bevestiging door Milano Worx vragen wij een aanbetaling van €15 (online of per overschrijving). Het restbedrag betaal je na de service.",
    },
    quote: {
      title: "Offerte aanvragen", sub: "In 3 stappen een vrijblijvende offerte.",
      s1: "Voertuig", s2: "Probleem / Dienst", s3: "Contactgegevens",
      next: "Volgende", back: "Vorige", send: "Offerte aanvragen", choose: "Kies de dienst",
      services: ["Onderhoud", "Reparatie", "Diagnose", "Remmen", "Distributie", "Koppeling", "Airco", "Autokeuring", "Sleepdienst", "Mobiele diagnose", "Verhuur", "Andere"],
      success: "Bedankt voor uw aanvraag. Ons team bekijkt uw aanvraag en neemt zo snel mogelijk contact met u op.",
    },
    appt: {
      title: "Afspraak maken", sub: "Kies uw dienst, voertuig en gewenste moment.",
      notice: "Uw afspraak is pas definitief nadat Milano Worx deze heeft bevestigd.",
      send: "Afspraak aanvragen",
      success: "Bedankt. Uw afspraak is aangevraagd en wordt zo snel mogelijk bevestigd.",
      slots: ["09:00 - 11:00", "11:00 - 13:00", "13:00 - 15:00", "15:00 - 17:00"],
      services: ["Onderhoud", "Reparatie", "Diagnose", "Airco", "Autokeuring", "Banden", "Andere"],
    },
    pricing: {
      title: "Tarieven",
      sub: "Transparante vanaf-prijzen voor onze meest gevraagde diensten.",
      rows: [
        ["Kleine onderhoud", "vanaf €120"],
        ["Grote onderhoud", "vanaf €250"],
        ["Oliewissel", "vanaf €79"],
        ["Remblokken (per as)", "vanaf €99"],
        ["Distributieriem", "vanaf €450"],
        ["Koppeling", "vanaf €650"],
        ["Diagnose + rapport", "vanaf €49"],
        ["Mobiele diagnose", "vanaf €89"],
        ["Airco service", "vanaf €89"],
        ["Autokeuring begeleiding", "vanaf €59"],
        ["Sleepdienst", "vanaf €85"],
        ["Werkplaats uurtarief", "€65/uur"],
      ],
      disclaimer: "Alle prijzen zijn indicatieve vanaf-prijzen incl. btw. De definitieve prijs hangt af van voertuig, onderdelen en diagnose. Vraag altijd een gratis offerte aan.",
      cta: "Gratis offerte aanvragen",
    },
    sale: {
      title: "Auto's te koop",
      sub: "Gecontroleerde tweedehandswagens, technisch in orde en klaar voor de keuring. Interesse? Neem contact op.",
      available: "Te koop",
      sold: "Verkocht",
      interest: "Interesse? Vraag info",
      modalTitle: "Info aanvragen",
      send: "Aanvraag versturen",
      success: "Bedankt voor uw interesse. Wij nemen zo snel mogelijk contact met u op.",
    },
    rental: {
      title: "Auto huren", sub: "Beschikbare voertuigen voor dag-, week- of maandverhuur.",
      cars: "Auto's", vans: "Bestelwagens", vanTitle: "Bestelwagen huren",
      day: "/dag", week: "/week", month: "/maand", deposit: "Borg",
      available: "Beschikbaar", unavailable: "Niet beschikbaar", seats: "zitplaatsen",
      request: "Deze auto aanvragen", reserve: "Bestelwagen reserveren",
      modalTitle: "Voertuig aanvragen", start: "Startdatum", end: "Einddatum", chosen: "Gekozen voertuig",
      send: "Aanvraag versturen",
      deliveryLabel: "Ophalen of levering",
      pickup: "Ophalen in de garage",
      delivery: "Levering aan huis",
      deliveryInfo: "Vaste uitrijkost €100 + €5/km vanaf Ijskelderstraat 12, Hoboken. De exacte kosten worden berekend op basis van de afstand.",
      deliveryAddress: "Leveringsadres",
      success: "Bedankt voor uw aanvraag. Wij bevestigen de beschikbaarheid zo snel mogelijk.",
    },
    contact: { title: "Contact", sub: "Wij helpen u graag — bel, app of mail ons.", route: "Route naar garage", hours: "Openingsuren", follow: "Volg ons", address: "Adres" },
    footer: { tag: "Automotive Service • Diagnostics • Mobility", quick: "Snelle links", services: "Diensten", rights: "Alle rechten voorbehouden.", privacy: "Privacybeleid", terms: "Algemene voorwaarden", contact: "Contact" },
    cookie: { text: "Deze website gebruikt alleen functionele cookies en verwerkt formuliergegevens volgens de GDPR. Meer info in onze privacyverklaring.", accept: "Akkoord" },
    privacy: {
      title: "Privacybeleid",
      body: [
        "Milano Worx Autogarage verwerkt persoonsgegevens (naam, telefoonnummer, e-mailadres, voertuiggegevens en foto's) uitsluitend om uw aanvraag, offerte of afspraak te behandelen, conform de Algemene Verordening Gegevensbescherming (AVG/GDPR).",
        "Uw gegevens worden nooit verkocht of gedeeld met derden voor marketingdoeleinden. U heeft het recht op inzage, correctie en verwijdering van uw gegevens.",
        "Voor vragen over uw gegevens kunt u contact met ons opnemen via e-mail of telefoon.",
      ],
    },
    terms: {
      title: "Algemene voorwaarden",
      body: [
        "Alle afspraken en offertes via deze website zijn aanvragen en worden pas definitief na schriftelijke of mondelinge bevestiging door Milano Worx Autogarage.",
        "Prijzen voor verhuur zijn indicatief en afhankelijk van beschikbaarheid. Voor verhuur geldt een borg die bij ophaling wordt voldaan.",
        "De uiteindelijke goedkeuring bij de autokeuring hangt af van het officiële controleorganisme.",
      ],
    },
    over: {
      title: "Over Milano Worx",
      p1: "Milano Worx Autogarage is een onafhankelijke garage in Antwerpen, gespecialiseerd in onderhoud, reparatie en elektronische diagnose van alle merken.",
      p2: "Wij combineren technische expertise met persoonlijke service en transparante prijzen. Van klassieke mechaniek tot moderne voertuigelektronica — wij lossen het op.",
      p3: "Particulier of bedrijf: bij Milano Worx staat uw mobiliteit centraal.",
    },
    wa: {
      general: "Hallo Milano Worx, ik wil graag informatie of een afspraak maken voor mijn auto.",
      diagnose: "Hallo Milano Worx, ik wil graag een diagnose afspraak maken voor mijn auto.",
      rental: "Hallo Milano Worx, ik wil graag informatie over een huurauto.",
      tow: "Hallo Milano Worx, ik heb een sleepdienst nodig.",
      quote: "Hallo Milano Worx, ik wil graag een offerte aanvragen.",
      sale: "Hallo Milano Worx, ik heb interesse in een tweedehandswagen.",
    },
  },
  fr: {
    nav: { home: "Accueil", diensten: "Services", verhuur: "Location", tekoop: "À vendre", offerte: "Devis", afspraak: "Rendez-vous", over: "À propos", contact: "Contact", bellen: "Appeler", whatsapp: "WhatsApp" },
    hero: {
      badge: "Automotive Service • Diagnostics • Mobility",
      title: "Votre partenaire automobile complet à Anvers",
      sub: "Entretien, réparations, diagnostic, contrôle technique, dépannage, location et diagnostic mobile à domicile.",
      cta1: "Prendre rendez-vous", cta2: "Demander un devis", cta3: "WhatsApp",
      p1: "Mécaniciens expérimentés", p2: "Prix transparents", p3: "Communication rapide",
    },
    home: {
      servicesTitle: "Nos services", servicesSub: "De l'entretien courant au diagnostic électronique complet — tout sous un même toit à Anvers.",
      howTitle: "Comment ça marche",
      steps: [
        { t: "1. Choisissez votre service", d: "Sélectionnez ce dont votre voiture a besoin." },
        { t: "2. Partagez les données du véhicule", d: "Marque, modèle, plaque et photos du problème." },
        { t: "3. Nous confirmons", d: "Devis ou rendez-vous — nous vous contactons rapidement via WhatsApp, téléphone ou e-mail." },
      ],
      whyTitle: "Pourquoi Milano Worx ?",
      whyItems: ["Diagnostic professionnel", "Service personnalisé", "Prix transparents", "Mécaniciens expérimentés", "Communication rapide", "Service automobile complet", "Contact WhatsApp", "Particuliers et entreprises"],
      reviewsTitle: "Ce que disent nos clients",
      reviewsSub: "Expériences réelles de clients d'Anvers et des environs.",
      reviewsCta: "Voir nos avis Google",
      reviewsNote: "Les avis Google en direct seront bientôt intégrés.",
      fleetTitle: "Clients professionnels & flottes",
      fleetDesc: "Milano Worx collabore avec des entreprises disposant de voitures, utilitaires et petites flottes.",
      fleetItems: ["Entretien & réparations", "Diagnostic", "Contrôle technique", "Pneus", "Planification rapide", "Priorité pour les flottes"],
      fleetCta: "Demander une collaboration B2B",
      garageTitle: "Notre atelier à Hoboken",
      garageSub: "Ijskelderstraat 12, 2660 Hoboken — votre voiture est entre de bonnes mains.",
      rentalTitle: "Location voiture & utilitaire",
      rentalSub: "Location flexible par jour, semaine ou mois. Demandez en ligne — nous confirmons la disponibilité.",
      rentalCta: "Voir la location",
      ctaTitle: "Prêt à commencer ?",
      ctaSub: "Demandez un devis aujourd'hui ou prenez directement rendez-vous.",
    },
    press: {
      title: "Dans la presse",
      sub: "Le district de Hoboken a mis Milano Worx en avant comme entrepreneur du mois.",
      articleTitle: "« Vakmanschap bij de broers van Milano Worx »",
      quote: "« Les clients nous complimentent souvent sur notre honnêteté. Nous cherchons le problème et en faisons une photo comme preuve. Ainsi, ils se sentent en confiance. »",
      source: "antwerpen.be — District Hoboken",
      cta: "Lire l'article complet",
      credit: "Photo : Pieter De Wilde / antwerpen.be",
    },
    pay: {
      title: "Acompte de 15 €",
      sub: "Milano Worx a confirmé votre demande. Payez l'acompte pour finaliser votre rendez-vous. Le solde se paie après le service.",
      service: "Service", ref: "Référence",
      online: "Payer 15 € en ligne",
      onlineDesc: "Carte, Bancontact ou Apple Pay — sécurisé via Stripe",
      transfer: "Virement bancaire",
      iban: "IBAN", beneficiary: "Bénéficiaire", communication: "Communication",
      copy: "Copier", copied: "Copié !",
      transferNote: "Utilisez la référence comme communication. Votre paiement est confirmé manuellement.",
      waitConfirm: "Milano Worx confirme d'abord votre demande. Vous recevrez ensuite une demande de paiement.",
      alreadyPaid: "Acompte reçu — merci ! Votre rendez-vous est définitif.",
      redirecting: "Redirection vers la page de paiement...",
      err: "Le paiement n'a pas pu démarrer. Réessayez ou payez par virement.",
      checking: "Vérification du paiement...",
      ok: "Paiement reçu",
      okText: "Votre acompte de 15 € a réussi. Milano Worx confirme définitivement votre rendez-vous.",
      fail: "Paiement pas encore confirmé",
      failText: "Le paiement n'est pas encore visible. Vous venez de payer ? Patientez et rechargez la page.",
      cancelTitle: "Paiement annulé",
      cancelText: "Pas de problème — vous pouvez payer plus tard via le lien reçu.",
      home: "Retour à l'accueil",
    },
    cards: [
      { id: "onderhoud", title: "Entretien & Réparation", desc: "Petit et grand entretien, huile, freins, distribution, embrayage, suspension, clim et plus.", badge: "Populaire" },
      { id: "diagnose", title: "Diagnostic & Électronique", desc: "Lecture des codes d'erreur, diagnostic ECU, capteurs et pannes électriques.", badge: "High-Tech" },
      { id: "mobiel", title: "Diagnostic Mobile", desc: "Diagnostic à domicile ou au bureau — sur rendez-vous dans la région d'Anvers.", badge: "À domicile" },
      { id: "keuring", title: "Contrôle Technique", desc: "Plaque Z, contrôle avant vente et contrôle périodique.", badge: "Sans souci" },
      { id: "sleep", title: "Dépannage", desc: "Panne ou voiture en défaut ? Dépannage rapide à Anvers et environs.", badge: "24/7" },
      { id: "verhuur", title: "Voiture & Utilitaire", desc: "Voitures et utilitaires en location par jour, semaine ou mois.", badge: "Flexible" },
      { id: "tekoop", title: "Voitures à vendre", desc: "Occasions contrôlées, prêtes pour le contrôle technique.", badge: "Occasions" },
    ],
    svc: {
      onderhoud: {
        title: "Entretien & Réparation",
        desc: "Service complet pour toutes les marques — du petit entretien aux réparations moteur complexes.",
        items: ["Petit entretien", "Grand entretien", "Vidange d'huile", "Freins", "Courroie de distribution", "Chaîne de distribution", "Embrayage", "Suspension", "Problèmes moteur", "Système de refroidissement", "Pannes électriques", "Climatisation", "Réparations générales"],
      },
      diagnose: {
        title: "Diagnostic & Électronique",
        desc: "Diagnostic électronique professionnel avec un équipement moderne pour toutes les marques.",
        items: ["Lecture des codes d'erreur", "Diagnostic électronique", "Recherche de pannes", "Diagnostic ECU", "Capteurs", "Problèmes électriques", "Programmation/codage si disponible"],
        cta: "Rendez-vous diagnostic",
      },
      mobiel: {
        title: "Diagnostic Mobile à Domicile",
        desc: "Voyant au tableau de bord ou problème de démarrage ? Nous venons chez vous ou au bureau sur rendez-vous.",
        success: "Merci. Milano Worx vous contactera dans les plus brefs délais pour confirmer le rendez-vous.",
        wa: "Demander directement via WhatsApp",
      },
      keuring: {
        title: "Service Contrôle Technique",
        z: "Contrôle technique plaque Z", zd: "Nous amenons votre véhicule au contrôle avec notre service plaque Z, le cas échéant.",
        verk: "Contrôle avant vente", verkd: "Accompagnement complet pour le contrôle technique avant la vente de votre véhicule.",
        per: "Contrôle périodique", perd: "Nous vous assistons pour le contrôle périodique normal de votre voiture.",
        disclaimer: "Attention : l'acceptation finale du véhicule dépend toujours de l'organisme de contrôle officiel.",
        cta: "Demander un contrôle",
        services: ["Contrôle plaque Z", "Contrôle avant vente", "Contrôle périodique"],
        serviceLabel: "Service souhaité",
        success: "Merci pour votre demande. Nous vous contacterons pour planifier le contrôle.",
      },
      sleep: {
        title: "Panne ou voiture en défaut ? Nous vous aidons.",
        sub: "Service de dépannage à Anvers et environs — rapidement sur place.",
        big: "Demander un dépannage",
        waLoc: "Envoyer la position via WhatsApp",
        call: "Appelez-nous",
        drives: "La voiture roule-t-elle encore ?",
        yes: "La voiture roule", no: "La voiture ne roule pas",
        reason: "Motif de la demande", loc: "Position actuelle", dest: "Destination", photo: "Photo (optionnel)",
        success: "Merci. Notre dépannage vous contactera dans les plus brefs délais.",
      },
    },
    form: {
      name: "Nom", phone: "Numéro de téléphone", email: "Adresse e-mail", address: "Adresse",
      brand: "Marque", model: "Modèle", year: "Année", plate: "Plaque d'immatriculation", vin: "VIN / numéro de châssis (optionnel)",
      km: "Kilométrage", fuel: "Carburant", transmission: "Transmission",
      date: "Date souhaitée", time: "Heure souhaitée", remarks: "Remarques",
      problem: "Décrivez le problème", photos: "Télécharger des photos (max. 5)",
      gdpr: "J'accepte le traitement de mes données conformément à la politique de confidentialité.",
      preferred: "Contact préféré", service: "Type de service", slot: "Créneau horaire",
      fuels: ["Essence", "Diesel", "Hybride", "Électrique", "GPL"],
      transmissions: ["Manuelle", "Automatique"],
      prefs: ["WhatsApp", "Téléphone", "E-mail"],
      depositNote: "Après confirmation par Milano Worx, nous demandons un acompte de 15 € (en ligne ou par virement). Le solde se paie après le service.",
    },
    quote: {
      title: "Demander un devis", sub: "Un devis sans engagement en 3 étapes.",
      s1: "Véhicule", s2: "Problème / Service", s3: "Coordonnées",
      next: "Suivant", back: "Précédent", send: "Demander un devis", choose: "Choisissez le service",
      services: ["Entretien", "Réparation", "Diagnostic", "Freins", "Distribution", "Embrayage", "Climatisation", "Contrôle technique", "Dépannage", "Diagnostic mobile", "Location", "Autre"],
      success: "Merci pour votre demande. Notre équipe l'examine et vous contactera dans les plus brefs délais.",
    },
    appt: {
      title: "Prendre rendez-vous", sub: "Choisissez votre service, véhicule et moment souhaité.",
      notice: "Votre rendez-vous n'est définitif qu'après confirmation par Milano Worx.",
      send: "Demander un rendez-vous",
      success: "Merci. Votre rendez-vous a été demandé et sera confirmé dans les plus brefs délais.",
      slots: ["09:00 - 11:00", "11:00 - 13:00", "13:00 - 15:00", "15:00 - 17:00"],
      services: ["Entretien", "Réparation", "Diagnostic", "Climatisation", "Contrôle technique", "Pneus", "Autre"],
    },
    pricing: {
      title: "Tarifs",
      sub: "Prix de départ transparents pour nos services les plus demandés.",
      rows: [
        ["Petit entretien", "dès 120 €"],
        ["Grand entretien", "dès 250 €"],
        ["Vidange d'huile", "dès 79 €"],
        ["Plaquettes de frein (par essieu)", "dès 99 €"],
        ["Courroie de distribution", "dès 450 €"],
        ["Embrayage", "dès 650 €"],
        ["Diagnostic + rapport", "dès 49 €"],
        ["Diagnostic mobile", "dès 89 €"],
        ["Service climatisation", "dès 89 €"],
        ["Accompagnement contrôle technique", "dès 59 €"],
        ["Dépannage", "dès 85 €"],
        ["Taux horaire atelier", "65 €/h"],
      ],
      disclaimer: "Tous les prix sont indicatifs, TVA comprise. Le prix final dépend du véhicule, des pièces et du diagnostic. Demandez toujours un devis gratuit.",
      cta: "Demander un devis gratuit",
    },
    sale: {
      title: "Voitures à vendre",
      sub: "Occasions contrôlées, techniquement en ordre et prêtes pour le contrôle technique. Intéressé ? Contactez-nous.",
      available: "À vendre",
      sold: "Vendue",
      interest: "Intéressé ? Demandez info",
      modalTitle: "Demander des infos",
      send: "Envoyer la demande",
      success: "Merci pour votre intérêt. Nous vous contacterons dans les plus brefs délais.",
    },
    rental: {
      title: "Louer une voiture", sub: "Véhicules disponibles à la journée, semaine ou au mois.",
      cars: "Voitures", vans: "Utilitaires", vanTitle: "Louer un utilitaire",
      day: "/jour", week: "/semaine", month: "/mois", deposit: "Caution",
      available: "Disponible", unavailable: "Indisponible", seats: "places",
      request: "Demander cette voiture", reserve: "Réserver l'utilitaire",
      modalTitle: "Demander un véhicule", start: "Date de début", end: "Date de fin", chosen: "Véhicule choisi",
      send: "Envoyer la demande",
      deliveryLabel: "Retrait ou livraison",
      pickup: "Retrait au garage",
      delivery: "Livraison à domicile",
      deliveryInfo: "Forfait de déplacement 100 € + 5 €/km depuis Ijskelderstraat 12, Hoboken. Le coût exact est calculé selon la distance.",
      deliveryAddress: "Adresse de livraison",
      success: "Merci pour votre demande. Nous confirmons la disponibilité dans les plus brefs délais.",
    },
    contact: { title: "Contact", sub: "Nous sommes à votre service — appelez, écrivez ou envoyez un e-mail.", route: "Itinéraire vers le garage", hours: "Heures d'ouverture", follow: "Suivez-nous", address: "Adresse" },
    footer: { tag: "Automotive Service • Diagnostics • Mobility", quick: "Liens rapides", services: "Services", rights: "Tous droits réservés.", privacy: "Politique de confidentialité", terms: "Conditions générales", contact: "Contact" },
    cookie: { text: "Ce site utilise uniquement des cookies fonctionnels et traite les données des formulaires conformément au RGPD. Plus d'infos dans notre politique de confidentialité.", accept: "Accepter" },
    privacy: {
      title: "Politique de confidentialité",
      body: [
        "Milano Worx Autogarage traite les données personnelles (nom, téléphone, e-mail, données du véhicule et photos) uniquement pour traiter votre demande, devis ou rendez-vous, conformément au RGPD.",
        "Vos données ne sont jamais vendues ni partagées avec des tiers à des fins marketing. Vous avez le droit de consulter, corriger et supprimer vos données.",
        "Pour toute question concernant vos données, contactez-nous par e-mail ou téléphone.",
      ],
    },
    terms: {
      title: "Conditions générales",
      body: [
        "Tous les rendez-vous et devis via ce site sont des demandes et ne deviennent définitifs qu'après confirmation par Milano Worx Autogarage.",
        "Les prix de location sont indicatifs et dépendent de la disponibilité. Une caution est exigée lors de la prise en charge du véhicule.",
        "L'acceptation finale au contrôle technique dépend de l'organisme de contrôle officiel.",
      ],
    },
    over: {
      title: "À propos de Milano Worx",
      p1: "Milano Worx Autogarage est un garage indépendant à Anvers, spécialisé dans l'entretien, la réparation et le diagnostic électronique de toutes les marques.",
      p2: "Nous combinons expertise technique, service personnalisé et prix transparents. De la mécanique classique à l'électronique moderne — nous trouvons la solution.",
      p3: "Particulier ou entreprise : chez Milano Worx, votre mobilité est au centre.",
    },
    wa: {
      general: "Bonjour Milano Worx, je souhaite des informations ou un rendez-vous pour ma voiture.",
      diagnose: "Bonjour Milano Worx, je souhaite un rendez-vous diagnostic pour ma voiture.",
      rental: "Bonjour Milano Worx, je souhaite des informations sur une voiture de location.",
      tow: "Bonjour Milano Worx, j'ai besoin d'un dépannage.",
      quote: "Bonjour Milano Worx, je souhaite demander un devis.",
      sale: "Bonjour Milano Worx, je suis intéressé par une voiture d'occasion.",
    },
  },
  en: {
    nav: { home: "Home", diensten: "Services", verhuur: "Rental", tekoop: "For sale", offerte: "Quote", afspraak: "Appointment", over: "About us", contact: "Contact", bellen: "Call", whatsapp: "WhatsApp" },
    hero: {
      badge: "Automotive Service • Diagnostics • Mobility",
      title: "Your complete car partner in Antwerp",
      sub: "Maintenance, repairs, diagnostics, vehicle inspection, tow service, rental and mobile diagnostics at your home.",
      cta1: "Book an appointment", cta2: "Request a quote", cta3: "WhatsApp us",
      p1: "Experienced mechanics", p2: "Transparent pricing", p3: "Fast communication",
    },
    home: {
      servicesTitle: "Our services", servicesSub: "From minor maintenance to full electronic diagnostics — all under one roof in Antwerp.",
      howTitle: "How it works",
      steps: [
        { t: "1. Choose your service", d: "Select what your car needs." },
        { t: "2. Share your vehicle details", d: "Brand, model, plate and photos of the problem." },
        { t: "3. We confirm", d: "Quote or appointment — we contact you quickly via WhatsApp, phone or email." },
      ],
      whyTitle: "Why Milano Worx?",
      whyItems: ["Professional diagnostics", "Personal service", "Transparent pricing", "Experienced mechanics", "Fast communication", "Complete car service", "WhatsApp contact", "Private & business customers"],
      reviewsTitle: "What our customers say",
      reviewsSub: "Real experiences from customers in Antwerp and surroundings.",
      reviewsCta: "View our Google reviews",
      reviewsNote: "Live Google reviews will be integrated soon.",
      fleetTitle: "Business customers & fleets",
      fleetDesc: "Milano Worx partners with companies with passenger cars, vans and small fleets.",
      fleetItems: ["Maintenance & repairs", "Diagnostics", "Inspection", "Tyres", "Fast scheduling", "Priority for fleet customers"],
      fleetCta: "Request a business partnership",
      garageTitle: "Our workshop in Hoboken",
      garageSub: "Ijskelderstraat 12, 2660 Hoboken — your car is in good hands here.",
      rentalTitle: "Car & van rental",
      rentalSub: "Flexible rental per day, week or month. Request online — we confirm availability.",
      rentalCta: "View rental",
      ctaTitle: "Ready to get started?",
      ctaSub: "Request a quote today or book an appointment right away.",
    },
    press: {
      title: "In the press",
      sub: "The Hoboken district put Milano Worx in the spotlight as entrepreneur of the month.",
      articleTitle: "“Vakmanschap bij de broers van Milano Worx”",
      quote: "“Customers often compliment us on our honesty. We track down the problem and take a photo of it as proof. That way they feel safe.”",
      source: "antwerpen.be — Hoboken District",
      cta: "Read the full article",
      credit: "Photo: Pieter De Wilde / antwerpen.be",
    },
    pay: {
      title: "€15 deposit",
      sub: "Milano Worx has confirmed your request. Pay the deposit to make your appointment final. The balance is paid after the service.",
      service: "Service", ref: "Reference",
      online: "Pay €15 online",
      onlineDesc: "Card, Bancontact or Apple Pay — secure via Stripe",
      transfer: "Bank transfer",
      iban: "IBAN", beneficiary: "Beneficiary", communication: "Reference",
      copy: "Copy", copied: "Copied!",
      transferNote: "Use the reference as payment communication. Your payment is confirmed manually.",
      waitConfirm: "Milano Worx confirms your request first. You will then receive a payment request.",
      alreadyPaid: "Deposit received — thank you! Your appointment is final.",
      redirecting: "Redirecting to the payment page...",
      err: "Payment could not be started. Try again or pay by bank transfer.",
      checking: "Checking payment...",
      ok: "Payment received",
      okText: "Your €15 deposit was successful. Milano Worx will definitively confirm your appointment.",
      fail: "Payment not yet confirmed",
      failText: "The payment is not visible yet. Just paid? Wait a moment and reload the page.",
      cancelTitle: "Payment cancelled",
      cancelText: "No problem — you can pay later via the link you received.",
      home: "Back to home",
    },
    cards: [
      { id: "onderhoud", title: "Maintenance & Repair", desc: "Minor and major service, oil, brakes, timing belt, clutch, suspension, A/C and more.", badge: "Popular" },
      { id: "diagnose", title: "Diagnostics & Electronics", desc: "Read fault codes, ECU diagnostics, sensors and trace electrical faults.", badge: "High-Tech" },
      { id: "mobiel", title: "Mobile Diagnostics", desc: "Diagnostics at your home or office — by appointment in the Antwerp region.", badge: "At home" },
      { id: "keuring", title: "Vehicle Inspection", desc: "Z-plate inspection, pre-sale inspection and periodic inspection.", badge: "Carefree" },
      { id: "sleep", title: "Tow Service", desc: "Breakdown or defective car? Fast towing in Antwerp and surroundings.", badge: "24/7" },
      { id: "verhuur", title: "Car & Van Rental", desc: "Rental cars and vans per day, week or month.", badge: "Flexible" },
      { id: "tekoop", title: "Cars for sale", desc: "Checked used cars, ready for inspection.", badge: "Used cars" },
    ],
    svc: {
      onderhoud: {
        title: "Maintenance & Repair",
        desc: "Complete general garage service for all brands — from minor maintenance to complex engine repairs.",
        items: ["Minor maintenance", "Major maintenance", "Oil change", "Brakes", "Timing belt", "Timing chain", "Clutch", "Suspension", "Engine problems", "Cooling system", "Electrical faults", "Air conditioning", "General repairs"],
      },
      diagnose: {
        title: "Diagnostics & Electronics",
        desc: "Professional electronic diagnostics with modern equipment for all brands.",
        items: ["Read fault codes", "Electronic diagnostics", "Fault tracing", "ECU diagnostics", "Sensors", "Electrical problems", "Programming/coding where available"],
        cta: "Book a diagnostics appointment",
      },
      mobiel: {
        title: "Mobile Diagnostics at Home",
        desc: "Warning light on the dashboard or starting problem? We come to your home or office by appointment.",
        success: "Thank you. Milano Worx will contact you as soon as possible to confirm the appointment.",
        wa: "Request directly via WhatsApp",
      },
      keuring: {
        title: "Vehicle Inspection Service",
        z: "Z-plate Inspection", zd: "We bring your vehicle to the inspection using our Z-plate service, where applicable.",
        verk: "Pre-sale Inspection", verkd: "Full assistance for the inspection before selling your vehicle.",
        per: "Periodic Inspection", perd: "We assist you with the regular periodic inspection of your car.",
        disclaimer: "Please note: final approval of the vehicle always depends on the official inspection body.",
        cta: "Request inspection",
        services: ["Z-plate inspection", "Pre-sale inspection", "Periodic inspection"],
        serviceLabel: "Desired service",
        success: "Thank you for your request. We will contact you to schedule the inspection.",
      },
      sleep: {
        title: "Breakdown or defective car? We help you.",
        sub: "Tow service in Antwerp and surroundings — quickly on site.",
        big: "Request tow service",
        waLoc: "Send location via WhatsApp",
        call: "Call us",
        drives: "Does the car still drive?",
        yes: "Car drives", no: "Car does not drive",
        reason: "Reason for the request", loc: "Current location", dest: "Destination", photo: "Photo (optional)",
        success: "Thank you. Our tow service will contact you as soon as possible.",
      },
    },
    form: {
      name: "Name", phone: "Phone number", email: "Email address", address: "Address",
      brand: "Brand", model: "Model", year: "Year", plate: "License plate", vin: "VIN / chassis number (optional)",
      km: "Mileage", fuel: "Fuel", transmission: "Transmission",
      date: "Preferred date", time: "Preferred time", remarks: "Remarks",
      problem: "Describe the problem", photos: "Upload photos (max. 5)",
      gdpr: "I agree to the processing of my data according to the privacy policy.",
      preferred: "Preferred contact", service: "Service type", slot: "Time slot",
      fuels: ["Petrol", "Diesel", "Hybrid", "Electric", "LPG"],
      transmissions: ["Manual", "Automatic"],
      prefs: ["WhatsApp", "Phone", "Email"],
      depositNote: "After confirmation by Milano Worx we ask for a €15 deposit (online or by bank transfer). The balance is paid after the service.",
    },
    quote: {
      title: "Request a quote", sub: "A no-obligation quote in 3 steps.",
      s1: "Vehicle", s2: "Problem / Service", s3: "Contact details",
      next: "Next", back: "Previous", send: "Request quote", choose: "Choose the service",
      services: ["Maintenance", "Repair", "Diagnostics", "Brakes", "Timing", "Clutch", "Air conditioning", "Inspection", "Tow service", "Mobile diagnostics", "Rental", "Other"],
      success: "Thank you for your request. Our team will review it and contact you as soon as possible.",
    },
    appt: {
      title: "Book an appointment", sub: "Choose your service, vehicle and preferred moment.",
      notice: "Your appointment is only final after Milano Worx has confirmed it.",
      send: "Request appointment",
      success: "Thank you. Your appointment has been requested and will be confirmed as soon as possible.",
      slots: ["09:00 - 11:00", "11:00 - 13:00", "13:00 - 15:00", "15:00 - 17:00"],
      services: ["Maintenance", "Repair", "Diagnostics", "Air conditioning", "Inspection", "Tyres", "Other"],
    },
    pricing: {
      title: "Price list",
      sub: "Transparent starting prices for our most requested services.",
      rows: [
        ["Minor service", "from €120"],
        ["Major service", "from €250"],
        ["Oil change", "from €79"],
        ["Brake pads (per axle)", "from €99"],
        ["Timing belt", "from €450"],
        ["Clutch", "from €650"],
        ["Diagnostics + report", "from €49"],
        ["Mobile diagnostics", "from €89"],
        ["A/C service", "from €89"],
        ["Inspection assistance", "from €59"],
        ["Tow service", "from €85"],
        ["Workshop hourly rate", "€65/hour"],
      ],
      disclaimer: "All prices are indicative starting prices incl. VAT. The final price depends on the vehicle, parts and diagnostics. Always request a free quote.",
      cta: "Request a free quote",
    },
    sale: {
      title: "Cars for sale",
      sub: "Checked used cars, technically sound and ready for inspection. Interested? Get in touch.",
      available: "For sale",
      sold: "Sold",
      interest: "Interested? Ask for info",
      modalTitle: "Request info",
      send: "Send request",
      success: "Thank you for your interest. We will contact you as soon as possible.",
    },
    rental: {
      title: "Rent a car", sub: "Available vehicles for daily, weekly or monthly rental.",
      cars: "Cars", vans: "Vans", vanTitle: "Rent a van",
      day: "/day", week: "/week", month: "/month", deposit: "Deposit",
      available: "Available", unavailable: "Not available", seats: "seats",
      request: "Request this car", reserve: "Reserve van",
      modalTitle: "Request vehicle", start: "Start date", end: "End date", chosen: "Chosen vehicle",
      send: "Send request",
      deliveryLabel: "Pick-up or delivery",
      pickup: "Pick-up at the garage",
      delivery: "Home delivery",
      deliveryInfo: "Fixed call-out fee €100 + €5/km from Ijskelderstraat 12, Hoboken. The exact cost is calculated based on the distance.",
      deliveryAddress: "Delivery address",
      success: "Thank you for your request. We will confirm availability as soon as possible.",
    },
    contact: { title: "Contact", sub: "We are happy to help — call, message or email us.", route: "Route to garage", hours: "Opening hours", follow: "Follow us", address: "Address" },
    footer: { tag: "Automotive Service • Diagnostics • Mobility", quick: "Quick links", services: "Services", rights: "All rights reserved.", privacy: "Privacy policy", terms: "Terms & conditions", contact: "Contact" },
    cookie: { text: "This website only uses functional cookies and processes form data according to the GDPR. More info in our privacy policy.", accept: "Accept" },
    privacy: {
      title: "Privacy policy",
      body: [
        "Milano Worx Autogarage processes personal data (name, phone, email, vehicle data and photos) solely to handle your request, quote or appointment, in accordance with the GDPR.",
        "Your data is never sold or shared with third parties for marketing purposes. You have the right to access, correct and delete your data.",
        "For questions about your data, contact us by email or phone.",
      ],
    },
    terms: {
      title: "Terms & conditions",
      body: [
        "All appointments and quotes via this website are requests and only become final after confirmation by Milano Worx Autogarage.",
        "Rental prices are indicative and subject to availability. A deposit is due upon vehicle pick-up.",
        "Final approval at the vehicle inspection depends on the official inspection body.",
      ],
    },
    over: {
      title: "About Milano Worx",
      p1: "Milano Worx Autogarage is an independent garage in Antwerp, specialised in maintenance, repair and electronic diagnostics of all brands.",
      p2: "We combine technical expertise with personal service and transparent pricing. From classic mechanics to modern vehicle electronics — we fix it.",
      p3: "Private or business: at Milano Worx, your mobility comes first.",
    },
    wa: {
      general: "Hello Milano Worx, I would like information or an appointment for my car.",
      diagnose: "Hello Milano Worx, I would like to book a diagnostics appointment for my car.",
      rental: "Hello Milano Worx, I would like information about a rental car.",
      tow: "Hello Milano Worx, I need a tow service.",
      quote: "Hello Milano Worx, I would like to request a quote.",
      sale: "Hello Milano Worx, I am interested in a used car.",
    },
  },
  it: {
    nav: { home: "Home", diensten: "Servizi", verhuur: "Noleggio", tekoop: "In vendita", offerte: "Preventivo", afspraak: "Appuntamento", over: "Chi siamo", contact: "Contatti", bellen: "Chiama", whatsapp: "WhatsApp" },
    hero: {
      badge: "Automotive Service • Diagnostics • Mobility",
      title: "Il tuo partner auto completo ad Anversa",
      sub: "Manutenzione, riparazioni, diagnosi, revisione, carroattrezzi, noleggio e diagnosi mobile a domicilio.",
      cta1: "Prenota un appuntamento", cta2: "Richiedi un preventivo", cta3: "Scrivici su WhatsApp",
      p1: "Meccanici esperti", p2: "Prezzi trasparenti", p3: "Comunicazione rapida",
    },
    home: {
      servicesTitle: "I nostri servizi", servicesSub: "Dalla piccola manutenzione alla diagnosi elettronica completa — tutto sotto lo stesso tetto ad Anversa.",
      howTitle: "Come funziona",
      steps: [
        { t: "1. Scegli il servizio", d: "Seleziona ciò di cui la tua auto ha bisogno." },
        { t: "2. Condividi i dati del veicolo", d: "Marca, modello, targa e foto del problema." },
        { t: "3. Confermiamo noi", d: "Preventivo o appuntamento — ti contattiamo rapidamente via WhatsApp, telefono o e-mail." },
      ],
      whyTitle: "Perché Milano Worx?",
      whyItems: ["Diagnosi professionale", "Servizio personale", "Prezzi trasparenti", "Meccanici esperti", "Comunicazione rapida", "Servizio auto completo", "Contatto WhatsApp", "Privati e aziende"],
      reviewsTitle: "Cosa dicono i nostri clienti",
      reviewsSub: "Esperienze reali di clienti di Anversa e dintorni.",
      reviewsCta: "Vedi le nostre recensioni Google",
      reviewsNote: "Le recensioni Google live saranno integrate a breve.",
      fleetTitle: "Clienti aziendali & flotte",
      fleetDesc: "Milano Worx collabora con aziende con autovetture, furgoni e piccole flotte.",
      fleetItems: ["Manutenzione & riparazioni", "Diagnosi", "Revisione", "Pneumatici", "Pianificazione rapida", "Priorità per le flotte"],
      fleetCta: "Richiedi una collaborazione aziendale",
      garageTitle: "La nostra officina a Hoboken",
      garageSub: "Ijskelderstraat 12, 2660 Hoboken — qui la tua auto è in buone mani.",
      rentalTitle: "Noleggio auto & furgoni",
      rentalSub: "Noleggio flessibile al giorno, settimana o mese. Richiedi online — confermiamo la disponibilità.",
      rentalCta: "Vedi il noleggio",
      ctaTitle: "Pronto a partire?",
      ctaSub: "Richiedi oggi un preventivo o prenota subito un appuntamento.",
    },
    press: {
      title: "Sulla stampa",
      sub: "Il distretto di Hoboken ha messo Milano Worx sotto i riflettori come imprenditore del mese.",
      articleTitle: "“Vakmanschap bij de broers van Milano Worx”",
      quote: "“I clienti ci fanno spesso i complimenti per la nostra onestà. Cerchiamo il problema e ne facciamo una foto come prova. Così si sentono al sicuro.”",
      source: "antwerpen.be — Distretto di Hoboken",
      cta: "Leggi l'articolo completo",
      credit: "Foto: Pieter De Wilde / antwerpen.be",
    },
    pay: {
      title: "Acconto di 15 €",
      sub: "Milano Worx ha confermato la tua richiesta. Paga l'acconto per rendere definitivo l'appuntamento. Il saldo si paga dopo il servizio.",
      service: "Servizio", ref: "Riferimento",
      online: "Paga 15 € online",
      onlineDesc: "Carta, Bancontact o Apple Pay — sicuro via Stripe",
      transfer: "Bonifico bancario",
      iban: "IBAN", beneficiary: "Beneficiario", communication: "Causale",
      copy: "Copia", copied: "Copiato!",
      transferNote: "Usa il riferimento come causale. Il pagamento viene confermato manualmente.",
      waitConfirm: "Milano Worx conferma prima la tua richiesta. Riceverai poi la richiesta di pagamento.",
      alreadyPaid: "Acconto ricevuto — grazie! Il tuo appuntamento è definitivo.",
      redirecting: "Reindirizzamento alla pagina di pagamento...",
      err: "Impossibile avviare il pagamento. Riprova o paga con bonifico.",
      checking: "Controllo del pagamento...",
      ok: "Pagamento ricevuto",
      okText: "Il tuo acconto di 15 € è andato a buon fine. Milano Worx conferma definitivamente l'appuntamento.",
      fail: "Pagamento non ancora confermato",
      failText: "Il pagamento non è ancora visibile. Hai appena pagato? Attendi un attimo e ricarica la pagina.",
      cancelTitle: "Pagamento annullato",
      cancelText: "Nessun problema — puoi pagare più tardi tramite il link ricevuto.",
      home: "Torna alla home",
    },
    cards: [
      { id: "onderhoud", title: "Manutenzione & Riparazione", desc: "Tagliandi, olio, freni, distribuzione, frizione, sospensioni, clima e altro.", badge: "Popolare" },
      { id: "diagnose", title: "Diagnosi & Elettronica", desc: "Lettura codici errore, diagnosi ECU, sensori e guasti elettrici.", badge: "High-Tech" },
      { id: "mobiel", title: "Diagnosi Mobile", desc: "Diagnosi a casa tua o in ufficio — su appuntamento nella regione di Anversa.", badge: "A domicilio" },
      { id: "keuring", title: "Revisione Auto", desc: "Revisione con targa Z, revisione pre-vendita e revisione periodica.", badge: "Senza pensieri" },
      { id: "sleep", title: "Carroattrezzi", desc: "Guasto o auto ferma? Soccorso rapido ad Anversa e dintorni.", badge: "24/7" },
      { id: "verhuur", title: "Auto & Furgoni", desc: "Auto e furgoni a noleggio al giorno, settimana o mese.", badge: "Flessibile" },
      { id: "tekoop", title: "Auto in vendita", desc: "Auto usate controllate, pronte per la revisione.", badge: "Usato" },
    ],
    svc: {
      onderhoud: {
        title: "Manutenzione & Riparazione",
        desc: "Servizio completo per tutte le marche — dal piccolo tagliando alle riparazioni motore complesse.",
        items: ["Piccolo tagliando", "Grande tagliando", "Cambio olio", "Freni", "Cinghia di distribuzione", "Catena di distribuzione", "Frizione", "Sospensioni", "Problemi motore", "Sistema di raffreddamento", "Guasti elettrici", "Climatizzatore", "Riparazioni generali"],
      },
      diagnose: {
        title: "Diagnosi & Elettronica",
        desc: "Diagnosi elettronica professionale con attrezzatura moderna per tutte le marche.",
        items: ["Lettura codici errore", "Diagnosi elettronica", "Ricerca guasti", "Diagnosi ECU", "Sensori", "Problemi elettrici", "Programmazione/codifica dove disponibile"],
        cta: "Prenota una diagnosi",
      },
      mobiel: {
        title: "Diagnosi Mobile a Domicilio",
        desc: "Spia sul cruscotto o problema di avviamento? Veniamo da te, a casa o in ufficio, su appuntamento.",
        success: "Grazie. Milano Worx ti contatterà al più presto per confermare l'appuntamento.",
        wa: "Richiedi direttamente via WhatsApp",
      },
      keuring: {
        title: "Servizio Revisione Auto",
        z: "Revisione con targa Z", zd: "Portiamo il tuo veicolo alla revisione con il nostro servizio targa Z, ove applicabile.",
        verk: "Revisione pre-vendita", verkd: "Assistenza completa per la revisione prima della vendita del veicolo.",
        per: "Revisione periodica", perd: "Ti assistiamo con la normale revisione periodica della tua auto.",
        disclaimer: "Attenzione: l'approvazione finale del veicolo dipende sempre dall'ente di controllo ufficiale.",
        cta: "Richiedi revisione",
        services: ["Revisione targa Z", "Revisione pre-vendita", "Revisione periodica"],
        serviceLabel: "Servizio desiderato",
        success: "Grazie per la richiesta. Ti contatteremo per programmare la revisione.",
      },
      sleep: {
        title: "Guasto o auto ferma? Ti aiutiamo noi.",
        sub: "Servizio carroattrezzi ad Anversa e dintorni — rapido sul posto.",
        big: "Richiedi carroattrezzi",
        waLoc: "Invia posizione via WhatsApp",
        call: "Chiamaci",
        drives: "L'auto si muove ancora?",
        yes: "L'auto si muove", no: "L'auto non si muove",
        reason: "Motivo della richiesta", loc: "Posizione attuale", dest: "Destinazione", photo: "Foto (opzionale)",
        success: "Grazie. Il nostro carroattrezzi ti contatterà al più presto.",
      },
    },
    form: {
      name: "Nome", phone: "Numero di telefono", email: "Indirizzo e-mail", address: "Indirizzo",
      brand: "Marca", model: "Modello", year: "Anno", plate: "Targa", vin: "VIN / numero telaio (opzionale)",
      km: "Chilometraggio", fuel: "Carburante", transmission: "Cambio",
      date: "Data desiderata", time: "Orario desiderato", remarks: "Note",
      problem: "Descrivi il problema", photos: "Carica foto (max. 5)",
      gdpr: "Accetto il trattamento dei miei dati secondo l'informativa privacy.",
      preferred: "Contatto preferito", service: "Tipo di servizio", slot: "Fascia oraria",
      fuels: ["Benzina", "Diesel", "Ibrida", "Elettrica", "GPL"],
      transmissions: ["Manuale", "Automatico"],
      prefs: ["WhatsApp", "Telefono", "E-mail"],
      depositNote: "Dopo la conferma di Milano Worx chiediamo un acconto di 15 € (online o bonifico). Il saldo si paga dopo il servizio.",
    },
    quote: {
      title: "Richiedi un preventivo", sub: "Un preventivo senza impegno in 3 passaggi.",
      s1: "Veicolo", s2: "Problema / Servizio", s3: "Contatti",
      next: "Avanti", back: "Indietro", send: "Richiedi preventivo", choose: "Scegli il servizio",
      services: ["Manutenzione", "Riparazione", "Diagnosi", "Freni", "Distribuzione", "Frizione", "Climatizzatore", "Revisione", "Carroattrezzi", "Diagnosi mobile", "Noleggio", "Altro"],
      success: "Grazie per la tua richiesta. Il nostro team la esaminerà e ti contatterà al più presto.",
    },
    appt: {
      title: "Prenota un appuntamento", sub: "Scegli servizio, veicolo e momento preferito.",
      notice: "L'appuntamento è definitivo solo dopo la conferma di Milano Worx.",
      send: "Richiedi appuntamento",
      success: "Grazie. Il tuo appuntamento è stato richiesto e sarà confermato al più presto.",
      slots: ["09:00 - 11:00", "11:00 - 13:00", "13:00 - 15:00", "15:00 - 17:00"],
      services: ["Manutenzione", "Riparazione", "Diagnosi", "Climatizzatore", "Revisione", "Pneumatici", "Altro"],
    },
    pricing: {
      title: "Listino prezzi",
      sub: "Prezzi di partenza trasparenti per i servizi più richiesti.",
      rows: [
        ["Piccolo tagliando", "da €120"],
        ["Tagliando completo", "da €250"],
        ["Cambio olio", "da €79"],
        ["Pastiglie freni (per asse)", "da €99"],
        ["Cinghia di distribuzione", "da €450"],
        ["Frizione", "da €650"],
        ["Diagnosi + report", "da €49"],
        ["Diagnosi a domicilio", "da €89"],
        ["Ricarica climatizzatore", "da €89"],
        ["Assistenza revisione", "da €59"],
        ["Carroattrezzi", "da €85"],
        ["Tariffa oraria officina", "€65/ora"],
      ],
      disclaimer: "Tutti i prezzi sono indicativi, IVA inclusa. Il prezzo finale dipende da veicolo, ricambi e diagnosi. Richiedi sempre un preventivo gratuito.",
      cta: "Richiedi un preventivo gratuito",
    },
    sale: {
      title: "Auto in vendita",
      sub: "Auto usate controllate, tecnicamente in ordine e pronte per la revisione. Interessato? Contattaci.",
      available: "In vendita",
      sold: "Venduta",
      interest: "Interessato? Chiedi info",
      modalTitle: "Richiedi info",
      send: "Invia richiesta",
      success: "Grazie per il tuo interesse. Ti contatteremo al più presto.",
    },
    rental: {
      title: "Noleggia un'auto", sub: "Veicoli disponibili per noleggio giornaliero, settimanale o mensile.",
      cars: "Auto", vans: "Furgoni", vanTitle: "Noleggia un furgone",
      day: "/giorno", week: "/settimana", month: "/mese", deposit: "Deposito",
      available: "Disponibile", unavailable: "Non disponibile", seats: "posti",
      request: "Richiedi questa auto", reserve: "Prenota il furgone",
      modalTitle: "Richiedi veicolo", start: "Data inizio", end: "Data fine", chosen: "Veicolo scelto",
      send: "Invia richiesta",
      deliveryLabel: "Ritiro o consegna",
      pickup: "Ritiro in garage",
      delivery: "Consegna a domicilio",
      deliveryInfo: "Tariffa fissa di uscita €100 + €5/km da Ijskelderstraat 12, Hoboken. Il costo esatto è calcolato in base alla distanza.",
      deliveryAddress: "Indirizzo di consegna",
      success: "Grazie per la richiesta. Confermeremo la disponibilità al più presto.",
    },
    contact: { title: "Contatti", sub: "Siamo a tua disposizione — chiama, scrivi o invia un'e-mail.", route: "Percorso verso il garage", hours: "Orari di apertura", follow: "Seguici", address: "Indirizzo" },
    footer: { tag: "Automotive Service • Diagnostics • Mobility", quick: "Link rapidi", services: "Servizi", rights: "Tutti i diritti riservati.", privacy: "Privacy policy", terms: "Termini e condizioni", contact: "Contatti" },
    cookie: { text: "Questo sito utilizza solo cookie funzionali e tratta i dati dei moduli secondo il GDPR. Maggiori info nella privacy policy.", accept: "Accetto" },
    privacy: {
      title: "Privacy policy",
      body: [
        "Milano Worx Autogarage tratta i dati personali (nome, telefono, e-mail, dati del veicolo e foto) esclusivamente per gestire la tua richiesta, preventivo o appuntamento, in conformità al GDPR.",
        "I tuoi dati non vengono mai venduti né condivisi con terzi per scopi di marketing. Hai diritto di accesso, rettifica e cancellazione dei tuoi dati.",
        "Per domande sui tuoi dati, contattaci via e-mail o telefono.",
      ],
    },
    terms: {
      title: "Termini e condizioni",
      body: [
        "Tutti gli appuntamenti e i preventivi tramite questo sito sono richieste e diventano definitivi solo dopo conferma da parte di Milano Worx Autogarage.",
        "I prezzi di noleggio sono indicativi e soggetti a disponibilità. È richiesto un deposito al ritiro del veicolo.",
        "L'approvazione finale alla revisione dipende dall'ente di controllo ufficiale.",
      ],
    },
    over: {
      title: "Chi è Milano Worx",
      p1: "Milano Worx Autogarage è un'officina indipendente ad Anversa, specializzata in manutenzione, riparazione e diagnosi elettronica di tutte le marche.",
      p2: "Combiniamo competenza tecnica, servizio personale e prezzi trasparenti. Dalla meccanica classica all'elettronica moderna — troviamo la soluzione.",
      p3: "Privato o azienda: da Milano Worx la tua mobilità viene prima di tutto.",
    },
    wa: {
      general: "Ciao Milano Worx, vorrei informazioni o un appuntamento per la mia auto.",
      diagnose: "Ciao Milano Worx, vorrei prenotare una diagnosi per la mia auto.",
      rental: "Ciao Milano Worx, vorrei informazioni su un'auto a noleggio.",
      tow: "Ciao Milano Worx, ho bisogno di un carroattrezzi.",
      quote: "Ciao Milano Worx, vorrei richiedere un preventivo.",
      sale: "Ciao Milano Worx, sono interessato a un'auto usata.",
    },
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("mw_lang") || "nl");
  const change = (l) => {
    setLang(l);
    localStorage.setItem("mw_lang", l);
  };
  const t = (path) => {
    const resolve = (d) => path.split(".").reduce((o, k) => (o ? o[k] : undefined), d);
    return resolve(dict[lang]) ?? resolve(dict.nl) ?? path;
  };
  return <LangContext.Provider value={{ lang, change, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
export const LANGS = ["nl", "fr", "en", "it"];
